'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var handleLotameLoad = function handleLotameLoad() {
  try {
    window.lotameGPTData = window.ccauds.Profile.Audiences.Audience.map(function (item) {
      return item.abbr;
    }).join(',');
  } catch (e) {}
};

var lotameRequested = false;

exports.default = function () {
  if (lotameRequested) {
    return;
  }

  lotameRequested = true;

  (function () {
    var lotameTargeting = document.createElement('script');

    lotameTargeting.async = true;
    lotameTargeting.type = 'text/javascript';
    lotameTargeting.src = 'https://ad.crwdcntrl.net/5/c=4724/pe=y/var=ccauds';
    lotameTargeting.onload = handleLotameLoad;

    var head = document.getElementsByTagName('head')[0];

    head.appendChild(lotameTargeting);
  })();
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-react-gpt/build/GooglePublisherTag/initLotameTargeting.js
 ** module id = 856
 ** module chunks = 0
 **/